<template>
    <div class="user_info_container" :class="locale==='en'?'user_info_container_en':''">
        <div class="user_info_main">
            <div class="user_info_content">
                <el-tabs v-model="activeName" @tab-change="changeTab" :tab-position="tabPosition" type="border-card" class="demo-tabs">
                    <el-tab-pane name="first" :label="$t('personalCenter.systemSettings')">
                        <div v-if="loadedInfo">
                            <div class="comfont_style">{{$t('personalCenter.accountProfile')}}</div>
                            <div class="account-info">
                                <div style="margin:32px 0px 24px 56px;" class="com_info font-bold">{{$t('personalCenter.basicInfo')}}</div>
                                <div class="com_info_mini1">
                                    <span class="info-label">{{$t('personalCenter.account')}}: </span>
                                    <span class="info-value">{{myIfo.mobile }}</span>
                                </div>
                                <div class="com_info_mini1">
                                    <span class="info-label">
                                        <!-- <span class="required mr-4 font-bold">*</span> -->
                                        {{$t('personalCenter.contactEmail')}}: 
                                    </span>
                                    <span class="info-value">{{ myIfo.email || $t('personalCenter.notBoundYet')}}</span>
                                    <span v-if="!myIfo.email" class="bind ml-8 cursor-pointer font-bold" @click="modifyEmail">{{$t('personalCenter.gotoBind')}}</span>
                                </div>
                                <div  class="com_info_mini1">
                                    <span class="info-label">
                                        <!-- <span class="required mr-4 font-bold">*</span> -->
                                        {{$t('personalCenter.accountPassword')}}: 
                                    </span>
                                    <span class="info-value">********</span>
                                    <span class="bind ml-8 cursor-pointer font-bold" @click="activeName = 'second'">{{$t('personalCenter.gotoChange')}}</span>
                                </div>
                                <div style="margin-top: 42px;" class="divider"></div>
                                <div class="com_info font-bold" style="margin:40px 0px 24px 56px;">{{$t('personalCenter.accountIdentity')}}</div>
                                <div  class="com_info_mini1">
                                    <span class="info-label">{{$t('personalCenter.accountIdentity')}}: </span>
                                    <span v-if="myIfo.authenticationResult == 2200" class="info-value">{{myIfo.authenticationType === '1' ? $t('personalCenter.individualDeveloper') :$t('personalCenter.enterpriseDeveloper') }}</span>
                                    <span class="info-value" v-else-if="myIfo.authenticationResult == 2400">{{$t('personalCenter.underCertification')}}</span>
                                    <span v-else>
                                        <span class="info-value">{{$t('personalCenter.notObtainedYet')}}</span>
                                        <span class="bind ml-8 cursor-pointer font-bold" @click="router.push({ path: '/home/controlrealauth' })">{{$t('personalCenter.goCertify')}}</span>
                                    </span>
                                </div>
                            </div>

                            <!-- // TODO 1.2内容 暂时隐藏订单中心 -->
                            <div class="addr_add_title" v-if="false">
                                <span class="addr_f">收件地址</span>
                                <span>
                                    <span class="addr_t">您还可以添加{{ 5 - addressList.length }}个</span>
                                    <el-link @click="openAddress" class="addr_add" type="primary"
                                        :style="{ opacity: addressList.length == 5 ? 0.4 : '' }" :underline="false"
                                        :disabled="addressList.length == 5">新增收件地址</el-link>
                                </span>
                            </div>
                            <el-table :header-cell-style="{ background: '#fcfcfc' }" class="addr_table" v-if="false" :data="addressList"
                                style="width: 100%">
                                <template #empty>
                                    <div class="empty-block">
                                        <img src="@/assets/image/empty@3x.png">
                                        <p>暂无数据</p>
                                    </div>
                                </template>
                                <el-table-column prop="receiveName" label="收件人" width="100" />
                                <el-table-column prop="receiveMobile" label="手机号码" width="220" align="center" />
                                <el-table-column prop="receiveArea" label="收件地址" width="300" align="center">
                                    <template #default="scope">
                                        <div class="des_one_row">{{ scope.row.receiveArea + ' ' + scope.row.detailAddress }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center">
                                    <template #default="scope">
                                        <el-button @click="updateAddr(scope.row)" type="text">编辑</el-button>
                                        <el-button @click="deleteAddr(scope.row.id)" style="margin: 0px 12px 0px 24px;"
                                            type="text">删除</el-button>
                                        <el-button v-if="scope.row.defaultAddress">默认地址</el-button>
                                        <el-button @click="handleAddressDefalut(scope.row.id)" type="text"
                                            v-else>设为默认</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                        </div>
                    </el-tab-pane>
                    <!-- // TODO 1.2内容 暂时隐藏订单中心 -->
                    <el-tab-pane name="fourth" label="订单中心" v-if="false">
                        <div style="font-size: 24px;" class="comfont_style">订单中心</div>
                        <div class="order_title">
                            <div style="width: 512px;">商品信息</div>
                            <span style="width: 80px;text-align: center;">支付金额</span>
                            <span style="width: 90px;text-align: center;margin-left: 40px;">订单状态</span>
                            <span style="width: 90px;text-align: right;">操作</span>
                        </div>
                        <div style="width: 100%; display: inline-block;"
                            class="divider"></div>
                        <div style="padding-top: 1px;min-height: 722px;" v-if="orderList.length">
                            <div class="order_item" :key="item.id" v-for="item in orderList">
                                <div>
                                    <div style="color: #999;font-size: 14px;"><span style="margin-right: 16px;">{{
                                        handledate(item.createTime) }}</span><span>订单号： {{ item.orderNo }}</span>
                                    </div>
                                    <div
                                        style="display: flex;margin-top: 20px;justify-content: space-between;align-items: center;">
                                        <div style="display: flex;width: 512px;">
                                            <img :src="item.mainPic" alt="">
                                            <div style="margin-left: 16px;">
                                                <div class="order_tit des_two_row">{{ item.productName }}</div>
                                                <div class="order_des des_two_row">{{ item.productDesc }}</div>
                                            </div>
                                        </div>
                                        <span style="width: 80px;text-align: center;color: #666;font-size: 14px;font-weight: 500;">￥{{
                                            formatNumber(item.actualAmount) }}</span>
                                        <span
                                            :style="{ color: statusColor[item.orderStatus], width: '90px', textAlign: 'center', fontSize: '14px', marginLeft: '40px' }">{{
                                                statusText[item.orderStatus] }}</span>
                                        <span style="width: 90px;text-align: right;">
                                            <el-button v-if="item.orderStatus == 0" @click="retryPayNow(item.id)"
                                                style="border: 1px solid #386AEA;background: #386AEA;color: #fff;">立即支付</el-button>
                                            <el-button
                                                @click="router.push({ path: '/home/orderDetail', query: { id: item.id } })"
                                                style="margin: 8px 0px;color: #386AEA;border: 0.5px solid #386AEA;background-color: #fff;">订单详情</el-button>
                                            <el-button v-if="item.orderStatus == 0" @click="cancelOrderProduct(item.id)"
                                                style="color: #666;border: 0.5px solid #999;background-color: #fff;">取消订单</el-button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <el-empty style="margin-top: 140px;" :image="require('@/assets/image/empty@3x.png')" :image-size="220"
                                description="暂无数据" />
                        </div>
                        <div v-if="orderList.length" style="width: 100%; display: inline-block;"
                            class="divider"></div>
                        <div v-if="orderList.length" class="paging-layout">
                            <div style="display: flex;justify-content: end;">
                                <span style="margin-right: 15px;font-size: 12px;color: #666;line-height: 24px;">共{{
                                    orderPageTotal }} {{$t('personalCenter.page')}}
                                    当前第{{ orderCurrentPage || 1 }}/{{ orderPageTotal }} {{$t('personalCenter.page')}}</span>
                                <span><el-pagination @current-change="orderChangeSize" :current-page="orderCurrentPage" small
                                        background layout="prev, pager, next" :default-page-size="4"
                                        :total="orderTotal" /></span>
                                <span style="font-size: 12px;color: #666;margin-left: 35px;">前往<input type='number'
                                        v-model="orderCurrentPage" @input="orderToPage"
                                        style="text-align: center; caret-color: #666; width: 24px; height: 24px; color: #666; font-weight: 500; outline: none;border: 1px solid #E6e6e6;margin: 0px 5px;">
                                    {{$t('personalCenter.page')}}</span>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="second" :label="$t('personalCenter.modifyPsw')">
                        <div>
                            <div class="comfont_style" style="margin-bottom: 40px;">{{$t('personalCenter.modifyPsw')}}</div>
                            <div class="pass_form">
                                <el-form ref="passwordform" :model="modedifyPasswordForm" :rules="rules1" :label-width="locale === 'en' ? '187px':'106px'">
                                    <el-form-item :label="$t('personalCenter.originalPsw')" prop="originPassword">
                                        <el-input :type="islook ? 'text' : 'password'" :placeholder="$t('personalCenter.writeOriginalPsw')"
                                            v-model.trim="modedifyPasswordForm.originPassword">
                                            <template #suffix>
                                                <div @click="islook = !islook">
                                                    <img v-if="!islook" src="@/assets/image/hide.svg" alt="">
                                                    <img v-else src="@/assets/image/look1.svg" alt="">
                                                </div>
                                            </template></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('personalCenter.newPsw')" prop="newpassword">
                                        <el-input :type="islook1 ? 'text' : 'password'" :placeholder="$t('personalCenter.writeNewPsw')"
                                            v-model.trim="modedifyPasswordForm.newpassword">
                                            <template #suffix>
                                                <div @click="islook1 = !islook1">
                                                    <img v-if="!islook1" src="@/assets/image/icon/hide-icon.png" alt="" width="24">
                                                    <img v-else src="@/assets/image/icon/look-icon.png" alt="" width="24">
                                                </div>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('personalCenter.confirmNewPsw')" prop="confirmPassword">
                                        <el-input :type="islook2 ? 'text' : 'password'" :placeholder="$t('personalCenter.rewriteLoginPsw')"
                                            v-model.trim="modedifyPasswordForm.confirmPassword">
                                            <template #suffix>
                                                <div @click="islook2 = !islook2">
                                                    <img v-if="!islook2" src="@/assets/image/icon/hide-icon.png" alt="" width="24">
                                                    <img v-else src="@/assets/image/icon/look-icon.png" alt="" width="24">
                                                </div>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                                <div class="handle_pass"> <el-button @click="modifyPassword" style="margin-left: 16px;"
                                        color="#386AEA">{{$t('login.confirm')}}</el-button></div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="third" :label="$t('personalCenter.systemNotice')">
                        <div>
                            <div class="comfont_style">
                                <span>{{$t('personalCenter.accountProfile')}}</span>
                                <span @click="handleMesRead" class="com_info_mini font-bold">{{$t('personalCenter.allAsRead')}}</span>
                            </div>
                            <div class="notice">
                                <div class="notice_title">
                                    <span style="width: 353px;font-size: 16px;">{{$t('personalCenter.noticeTitle')}}</span>
                                    <span style="width: 50px; text-align: center;">{{$t('personalCenter.status')}}</span>
                                    <span style="width: 130px; text-align: center;">{{$t('personalCenter.type')}}</span>
                                    <span style="width: 100px; text-align: right;">{{$t('personalCenter.releaseTime')}}</span>
                                </div>
                            
                            
                                <div class="system-message">
                                    <div @click="router.push({ path: '/home/controldetail', query: { type: 'permessage', id: item.id } })"
                                        v-for="item in noticeList" :key="item.id" class="notice_item">
                                        <span class="des_one_row" style="width: 353px;font-weight: 500;">{{ item.title }}</span>
                                        <span style="width: 50px;text-align: center;">
                                            <span style="color: #999; " v-if="item.readFlag">{{$t('personalCenter.read')}}</span>
                                            <el-badge v-else is-dot class="item">{{$t('personalCenter.unread')}}</el-badge>
                                        </span>
                                        <span style="width: 130px; text-align: center;">{{$t('personalCenter.certificationReview')}}</span>
                                        <span style="width: 100px; text-align: center;">{{ handledate(item.createTime) }}</span>
                                    </div>
                                </div>

                                <div style="width: 100%; display: inline-block;" class="divider"></div>
                                <div class="paging-layout">
                                    <span style="margin-right: 15px;font-size: 12px;color: #666;line-height: 24px;">{{$t('personalCenter.totalPage')}} {{
                                        pageTotal }} {{$t('personalCenter.page')}} <span v-if="locale === 'en'">{{'&nbsp;'}}</span>
                                        {{$t('personalCenter.currentPage')}}{{ currentPage || 1 }}/{{ pageTotal }} {{$t('personalCenter.page')}}</span>
                                    <span><el-pagination @current-change="changeSize" :current-page="currentPage" small
                                            background layout="prev, pager, next" :default-page-size="13"
                                            :total="total" /></span>
                                    <span style="font-size: 12px;color: #666;margin-left: 35px;" >{{$t('personalCenter.toPage')}}<input type='number'
                                            v-model="currentPage" @input="toPage"
                                            style="text-align: center; caret-color: #666; width: 24px; height: 24px; color: #666; font-weight: 500; outline: none;border: 1px solid #E6e6e6;margin: 0px 5px;">
                                        {{$t('personalCenter.page')}}</span>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog class="email_dia" :showClose="false" v-model="centerDialogVisible" :title="$t('personalCenter.bindEmail')" width="560px" center
            @close="resetForm">
            <el-form ref="form" :model="projectForm" :rules="rules" label-width="80px">
                <el-form-item prop="email">
                    <el-input :placeholder="$t('personalCenter.writeBindEmail')" v-model.trim="projectForm.email"></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 30px;" prop="code">
                    <el-input :placeholder="$t('register.verificationCode')" v-model.trim="projectForm.code">
                        <template #suffix>
                            <span @click.stop="sendCode" v-if="!isSend"
                                style="color: #386AEA; cursor: pointer;">{{$t('personalCenter.getVerificationCode')}}</span>
                            <span v-else style="color: #6a6a6a; cursor: pointer;">{{locale==='en'? $t("register.resendCodeTips")+codeTime+ 's': codeTime + $t("register.resendCodeTips") }}</span>
                        </template>
                    </el-input>
                </el-form-item>

            </el-form>
            <div class="bot_btn">
                <el-button @click="centerDialogVisible = false" color="#666">{{$t('personalCenter.cancel')}}</el-button>
                <el-button @click="verifyEmail" style="margin-left: 16px;" color="#386AEA">{{$t('personalCenter.confirm')}}</el-button>
            </div>
        </el-dialog>
        <Address :formData="formData" v-if="addressFlag" @close="closeAddress" :Visible="addressFlag"></Address>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, watch, computed, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getMyInfoApi, sendEmailCode, bindEmail, modifySecret, getUserNoticeList, markReadAll } from '@/api/control'
import { getOrderList, cancelOrder, payNow } from '@/api/shop'
import { handledate, validatePassword, validateCode } from '@/utils/common'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from 'vuex'
import { Encrypt } from '@/utils/crypt.util.js'
import { debounce } from '@/utils/common'
import Address from '@/components/address'
import { getAddressList, defaultAddress, deleteAddress } from '@/api/shop'
import { formatNumber } from "@/utils/common.js"
import {setEmail} from "@/utils/cookies"
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

const addressFlag = ref(false)
const statusColor = ref(
    { 0: '#E70A27', 1: '#999', 2: '#666', 3: '#999', 4: '#666', 5: '#666' },
)
const statusText = ref(
    { 0: '待支付', 1: '已取消', 2: '订金支付完成', 3: '支付超时', 4: '退款中', 5: '已退款' },
)
const store = useStore()
const router = useRouter()
const route = useRoute()
const tabPosition = ref('left')
const activeName = ref('')
let total = ref(0)
const currentPage = ref(1)
const centerDialogVisible = ref(false)
//表单dom
let islook = ref(false)
let islook1 = ref(false)
let islook2 = ref(false)
const form = ref(null)
const passwordform = ref(null)
const isSend = ref(false)//是否发送验证码
const codeTime = ref(300) //验证码倒计时
let timerId;//定义一个变量存储定时器 
let myIfo = ref({})
const loadedInfo = ref(false)
let noticeList = ref([])
const modedifyPasswordForm = ref({
    originPassword: '',
    newpassword: '',
    confirmPassword: ''
})
const projectForm = ref({
    email: '',
    code: ''
})
//表单校验规则
const rules = ref({
    email: [{ required: true, message: t("login.pleaseEnterEmail"), trigger: 'blur' }],
    code: [{ required: true, message: t("personalCenter.writeCodeYzm"), trigger: 'blur' }, { validator: validateCode, trigger: 'blur' }],
})

// 新增：防止互相验证时无限循环的锁
const validatingPasswords = ref(false)
//验证两次密码是否一样
const comparePasswords = (rule, value, callback) => {
  const newPwd = modedifyPasswordForm.value.newpassword
  const confirmPwd = modedifyPasswordForm.value.confirmPassword

  if (rule.field === 'newpassword') {
    if (confirmPwd && value !== confirmPwd) {
      callback(new Error(t("register.pswnomatch")))
    } else {
      callback()
    }

    // 主动触发一次对方验证以同步错误显示/清除，防止重复触发造成循环
    if (!validatingPasswords.value) {
      validatingPasswords.value = true
      nextTick(() => {
        passwordform.value && passwordform.value.validateField('confirmPassword')
        // 小延时释放锁，保证上一轮 validateField 能完成
        setTimeout(() => {
          validatingPasswords.value = false
        }, 0)
      })
    }
  } else if (rule.field === 'confirmPassword') {
    if (value !== newPwd) {
      callback(new Error(t("register.pswnomatch")))
    } else {
      callback()
    }

    if (!validatingPasswords.value) {
      validatingPasswords.value = true
      nextTick(() => {
        passwordform.value && passwordform.value.validateField('newpassword')
        setTimeout(() => {
          validatingPasswords.value = false
        }, 0)
      })
    }
  } else {
    callback()
  }
}


/*
const comparePasswords = (rule, value, callback) => {
    const newPwd = modedifyPasswordForm.value.newpassword
    const confirmPwd = modedifyPasswordForm.value.confirmPassword
    if(!(newPwd.length>0 && confirmPwd.length>0)) return;
    // 当验证 newpassword 字段时，如果与 confirm 不一致，给 newpassword 标记错误并触发 confirm 的校验以显示两个错误
    if (rule.field === 'newpassword') {
        if (confirmPwd && value !== confirmPwd) {
            callback(new Error(t("register.pswnomatch")))
            // 同步触发 confirmPassword 的校验，确保右侧也显示错误
            nextTick(() => {
                passwordform.value && passwordform.value.validateField('confirmPassword')
            })
        } else {
            callback()
            // 如果一致或 confirm 为空，仍触发一次 confirm 的校验以清除可能的旧错误
            nextTick(() => {
                passwordform.value && passwordform.value.validateField('confirmPassword')
            })
        }
    } else if (rule.field === 'confirmPassword') {
       // 当验证 confirmPassword 字段时，直接与 newpassword 比较并返回错误或通过
        if (value !== newPwd) {
            callback(new Error(t("register.pswnomatch")))
        } else {
            callback()
        }
    } else {
        callback()
    }
}*/

//表单校验规则
const rules1 = ref({
    originPassword: [
        { required: true, message: t("personalCenter.writeOriginalPswWarn"), trigger: 'blur' }, { validator: validatePassword, trigger: 'blur' }
    ],
    newpassword: [
        { required: true, message: t("personalCenter.writeNewPswWarn"), trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' },
        { validator: comparePasswords, trigger: 'blur' },
    ],
    confirmPassword: [
        { required: true, message: t("personalCenter.rewriteLoginPswWarn"), trigger: 'blur' }, 
        { validator: validatePassword, trigger: 'blur' },
        { validator: comparePasswords, trigger: 'blur' },
    ],
})
//地址列表
const addressList = ref([])
const formData = ref({})
const getAddress = () => {
    // TODO 1.2接口
    // getAddressList().then(res => {
    //     addressList.value = res.result
    // }).catch(err => { console.log(err); })
}
const handleAddressDefalut = (id) => {
    console.log('id', id);
    // TODO 1.2接口
    // defaultAddress(id).then(res => {
    //     if (res.code === 200) {
    //         getAddress()
    //         ElMessage({
    //             message: res.message,
    //             customClass: "custom-message1",
    //         });
    //         centerDialogVisible.value = false
    //     }
    // }).catch(err => { console.log(err); })
}
const deleteAddr = (id) => {
    const cancelMesBox = ElMessageBox.confirm('', '', {
        message: '是否确定删除收件地址？',
        title: '删除收件地址',
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: true,
        showClose: false,
        showCancelButton: true,
        center: true,
        autofocus: false,
        customClass: 'zhi_cancel',
        beforeClose: (action, instance, done) => {
            console.log(action);
            if (action === 'cancel') {
                done()
            } else {
                deleteAddress(id).then(res => {
                    if (res.code === 200) {
                        getAddress()
                        done()
                        ElMessage({
                            message: res.message,
                            customClass: "custom-message1",
                        });
                        centerDialogVisible.value = false
                    }
                }).catch(err => { console.log(err); })
            }
        }
    })
}
const updateAddr = (row) => {
    formData.value = JSON.parse(JSON.stringify(row))
    addressFlag.value = true
}
const closeAddress = () => {
    formData.value = {}
    getAddress()
    addressFlag.value = false
}
//订单分页相关
const orderCurrentPage = ref(1)
const orderTotal = ref(1)
const orderPageTotal = computed(() => {
    //   console.log(total.value);
    return Math.ceil(orderTotal.value / 4);
});
const orderChangeSize = (limit) => {
    orderCurrentPage.value = limit
    getOrList(limit)
}
//前往第几页 
const orderToPage = () => {
    console.log(orderCurrentPage.value , orderPageTotal);
    if(currentPage.value == ''){
        return
    }else if(orderCurrentPage.value > orderPageTotal.value ){
        orderCurrentPage.value = orderPageTotal.value
    }else if(orderCurrentPage.value < 0){
        orderCurrentPage.value = 1
    }
    getOrList(orderCurrentPage.value)
}
const orderList = ref([])
//获取订单列表
const getOrList = (limit = 1) => {
    getOrderList({ limit, offset: 4 }).then(res => {
        if (res.code == 200) {
            orderList.value = res.result.data
            orderTotal.value = res.result.count
        }
        console.log(res);
    }).catch(err => { console.log(err); })
}
//取消订单
const cancelOrderProduct = (id) => {
    //是否取消订单
    const cancelMesBox = ElMessageBox.confirm('', '', {
        message: '是否确定取消订单',
        title: '取消订单',
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showClose: false,
        showCancelButton: true,
        center: true,
        autofocus: false,
        customClass: 'zhi_cancel',
        beforeClose: (action, instance, done) => {
            console.log(action, id);
            if (action === 'cancel') {
                done()
            } else {
                done()
                cancelOrderMes(id)
            }
        }
    })
}
const cancelOrderMes = debounce((id) => {
    cancelOrder(id).then(res => {
        console.log(res);
        if (res.code == 200) {
            getOrList()
            ElMessage({
                message: res.message,
                customClass: "custom-message1",
            });
        }
    }).catch(err => { console.log(err); })
}, 1000)
const payString = ref('')
//跳转收银台
const toPay = () => {
    // 添加之前先删除一下，单页面，页面不刷新，添加进去的内容会一直保留在页面中，二次调用form表单会出错
    let divForm = document.getElementsByTagName('divform')
    console.log(divForm, divForm.length);
    if (divForm.length) {
        document.body.removeChild(divForm[0])
    }
    const div = document.createElement('divform');
    div.innerHTML = payString.value; // data就是接口返回的form 表单字符串
    // console.log(div,payString);
    document.body.appendChild(div);
    // nextTick(() => {
    //     console.log(document.forms);
    // })
    document.forms[1].setAttribute('target', '_blank') // 新开窗口跳转
    document.forms[1].submit();
}
//获取支付表单
const retryPayNow = (id) => {
    payNow({ id }).then(res => {
        if (res.code == 200) {
            payString.value = res.result.payHtml
            toPay()
        }
    }).catch(err => { console.log(err); })
}
//打开地址
const openAddress = () => {
    addressFlag.value = true
    // console.log(addressFlag.value);
}
//清空表单
const resetForm = () => {
    // projectForm.value.email = ''
    // projectForm.value.code = ''
    form.value.resetFields()
    isSend.value = false
    clearInterval(timerId)
    codeTime.value = 300
}
const pageTotal = computed(() => {
    //   console.log(total.value);
    return Math.ceil(total.value / 13);
});
//绑定邮箱
const verifyEmail = () => {
    form.value.validate((value) => {
        if (value) {
            bindEmail({ email: projectForm.value.email, emailCode: projectForm.value.code }).then(res => {
                if (res.code == 200) {
                    centerDialogVisible.value = false
                    setEmail(projectForm.value.email)
                    getMydetail()
                    ElMessage({
                        message: res.message,
                        customClass: "custom-message1",
                    });
                }
            }).catch(err => { console.log(err); })
        }
    })

}
const modifyEmail = () => {
    centerDialogVisible.value = true
}
//修改密码
const modifyPassword = () => {
    console.log(modedifyPasswordForm.value);
    let { originPassword, newpassword, confirmPassword } = modedifyPasswordForm.value
    passwordform.value.validate((value) => {
        if (value) {
            modifySecret({ password: Encrypt(originPassword), newPassword: Encrypt(newpassword), confirmNewPassword: Encrypt(confirmPassword) }).then(res => {
                if (res.code == 200) {
                    passwordform.value.resetFields()
                    ElMessage({
                        message: res.message,
                        customClass: "custom-message1",
                    });
                }
            }).catch(err => { console.log(err); })
        }
    })
}
//全部已读
const handleMesRead = () => {
    markReadAll().then(res => {
        console.log(res);
        if (res.code === 200) {
            getMessage()
            store.dispatch('getUserUnReadNum')
            ElMessage({
                message: res.message,
                customClass: "custom-message1",
            });
        }
    })
}
//获取个人信息
const getMydetail = () => {
    getMyInfoApi().then(res => {
        loadedInfo.value = true
        if (res.code == 200) {
            myIfo.value = res.result
        }
    }).catch(err => { 
        loadedInfo.value = true
        console.log(err); 
    })
}
//前往第几页 
const toPage = () => {
    if(currentPage.value == ''){
        return
    }else if(currentPage.value > pageTotal.value ){
        currentPage.value = pageTotal.value
    }else if(currentPage.value <= 0){
        currentPage.value = 1
    }
    getMessage(currentPage.value)
}
//分页按钮改变
const changeSize = (limit) => {
    currentPage.value = limit
    getMessage(limit)
}
//获取用户通知分页列表
const getMessage = (limit = 1, offset = 13) => {
    getUserNoticeList({ limit, offset }).then(res => {
        total.value = res.result.count
        noticeList.value = res.result.data
    }).catch(err => { console.log(err); })
}
// watch(
//     activeName,
//     (val) => {
//         if (val === 'first') {
//             getMydetail()
//         }else if(val === 'third'){
//             getMessage()
//         }
//     },
//     { immediate: true }
// )
watch(
    route,
    (val) => {
        // console.log(val.query.type);
        activeName.value = val.query.type
        if (val.query.type === 'first') {
            getMydetail()
            getAddress()
        } else if (val.query.type === 'third') {
            getMessage()
        } else if (val.query.type === 'fourth') {
            getOrList()
        }
    },
    { immediate: true }
)
const changeTab = (event) => {
    router.push({ path: '/home/controlinformation', query: { type: event } })
}
// onBeforeMount(() => {
//     activeName.value = route.query.type || 'first'
// })
// 发送验证码
const sendCode = debounce(async () => {
    let flag = false
    await form.value.validateField('email', err => {
        if (isSend.value || !err) {
            flag = true
        }
    })
    // console.log(flag);
    if (flag) return
    sendEmailCode({ email: projectForm.value.email }).then(res => {
        console.log(res);
        if (res.code === 200) {
            clearInterval(timerId)
            ElMessage({
                message: t("register.codeSend"),
                customClass: "custom-message1",
            });
            isSend.value = true
            timerId = setInterval(() => {
                codeTime.value = codeTime.value - 1
                if (codeTime.value == 0) {
                    clearInterval(timerId)
                    isSend.value = false
                    codeTime.value = 300
                }
            }, 1000)
        }
    })
}, 1000) 
</script>

<style lang="scss" scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.user_info_content {
    height: 960px;
    overflow: hidden;
    .el-tabs {
        height: 100%;
        .is-active {
            border: none;
        }
    }
}

.account-info {
    padding: 0 24px;
}

.des_two_row {
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -webkit-ellipsis-lastline;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

/**订单相关样式 */
.order_item {
    margin-bottom: 40px;

    .el-button {
        width: 64px;
        height: 24px;
        font-size: 12px;
        border-radius: 2px;
        font-weight: 500;
    }

    // .el-button:hover {
    //     background-color: #fff;
    // }

    .order_tit {
        color: #666;
        // font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
        width: 277px;
    }

    .order_des {
        margin-top: 8px;
        color: #666;
        width: 277px;
        // font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
    }

    img {
        width: 138px;
        height: 104px;
        border-radius: 4px;
    }
}

.order_item:last-child {
    margin-bottom: 20px;
}

.order_title {
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
    color: #666;
}

/**订单相关样式-------end */
/**地址相关样式 */
.addr_add_title {
    display: flex;
    justify-content: space-between;
    margin-top: 82px;
    margin-bottom: 16px;

    .addr_f {
        color: #333;
        // font-family: PingFang SC;
        font-weight: 500;
    }

    .addr_t {
        color: #666;
        // font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
        margin-right: 32px;
    }

    .addr_add {
        color: #386AEA;
        // font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
    }
}

/**地址相关样式 ---end */
.notice {
    margin-top: 24px;

    .notice_title {
        display: flex;
        justify-content: space-between;
        color: #333;
        height: 56px;
        line-height: 56px;
        margin-bottom: 24px;
        background: rgba(0, 0, 0, 0.01);
        padding: 0 24px;
    }

    .notice_item {
        display: flex;
        justify-content: space-between;
        color: #333;
        font-size: 14px;
        // font-weight: 500;
        margin: 30px 0px;
        cursor: pointer;
    }
    .notice_item:last-of-type{
        margin:30px 0 14px!important;
    }

    ::v-deep sup.el-badge__content.el-badge__content--danger.is-fixed.is-dot {
        top: 4px;
        right: -4px;
        height: 6px;
        width: 6px;
        background-color: #E70A27;
    }
}

.system-message {
    padding: 0 24px;
    height: 700px;
    padding-bottom: 10px;
}

.paging-layout {
    display: flex;
    justify-content: flex-end;
    margin-right: 24px;
}

/**分页 */
::v-deep li.is-active.number {
    background-color: #386AEA !important;
}

::v-deep .el-pager li,
.btn-prev,
::v-deep button.btn-prev.is-first,
::v-deep button.btn-next.is-last {
    margin: 0px !important;
    box-shadow: 0 0 0 0.5px #e6e6e6;
    border-radius: 0px;
    // border: 0.5px solid #66666648;
}

::v-deep .el-pager li.number {
    background-color: #fff;
    color: #666;
    font-weight: 500;
}
::v-deep .el-pager li.btn-quicknext, ::v-deep .el-pager li.btn-quickprev {
    background-color: #fff;
    color: #666;
    font-weight: 500;
}
::v-deep .el-pagination .el-icon{
    fill: #999;
}
/**分页------end */


.divider {
    position: relative;
    height: 1px;
    margin-bottom: 32px;
}

.divider:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0px;
    right: 0;
    height: 0.5px;
    background-color: rgba(0, 0, 0, 0.1);
}

.pass_form {
    margin-left: 80px;
    width: 506px;  
    padding-top: 8px;
    ::v-deep .el-form-item.is-error {
        margin-bottom: 48px;
    }

    ::v-deep .el-form-item {
        width: 503px;  
        margin: 0 auto 16px;
        align-items: center;
    }

    ::v-deep .el-button {
        width: 400px;
        margin-left: 106px !important;
        margin-top: 24px;
    }

    ::v-deep .el-form-item__label {
        padding-right: 24px;
        color: #333;
        font-weight: 500;
    }

    ::v-deep .el-input__wrapper {
        width: 400px;
    }
}

/**弹窗 */
::v-deep .el-form-item.is-error .el-input__wrapper {
    box-shadow: 0 0 0 0.5px #E70A27 inset !important;
}

::v-deep .el-form-item__error {
    color: #E70A27;
    line-height: 24px;
    padding-top: 0px;
    margin: 8px 0px 16px;
    font-weight: bold;
}

.handle_pass {
    ::v-deep .el-button {
        // width: 232px;
        height: 64px;
        color: #FFF;
        // font-family: PingFang SC;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
}


.bot_btn {
    margin: 48px 0px 10px 15px;

    ::v-deep .el-button {
        width: 232px;
        height: 64px;
        color: #FFF;
        // font-family: PingFang SC;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
}

::v-deep .el-input__wrapper {
    min-height: 64px;
    padding: 1px 24px;
    background: rgba(0, 0, 0, 0.05)
}

::v-deep .el-input__wrapper {
    box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.2) inset !important;
}

::v-deep .el-input__inner::placeholder {
    color: #000;
    // font-family: PingFang SC;
    font-size: 16px;
    opacity: 0.4;
    font-style: normal;
    font-weight: 400;
    line-height: 200%;
}



::v-deep .el-form-item__content {
    margin-left: 0px !important;
}

::v-deep .email_dia .el-dialog__header {
    padding-top: 40px;
    padding-bottom: 15px;
}

::v-deep .email_dia.el-dialog {
    top: 50%;
    transform: translateY(-50%);
    margin: 0 auto;
    border-radius: 4px;

}

::v-deep .email_dia {
    .el-form-item {
        width: 400px;
        margin: 0 auto;
    }
}


.des_one_row {
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -webkit-ellipsis-lastline;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    
}

::v-deep .el-dialog__title {
    color: #333;
    // font-family: PingFang SC;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

/************************ */
.pinpa {
    color: #386AEA;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 700;
}

.com_info {
    color: #333;
    font-size: 20px;
}

.com_info_mini {
    color: #333;
    font-size: 12px;
    cursor: pointer;
}
.com_info_mini1 {
    color: #333;
    font-size: 16px;
    font-weight: 400;
    margin-top: 21px;
    margin-left: 56px;
    display: flex;
    align-items: center;
    .info-label {
        width: 80px;
        font-size: 16px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 16px;
        font-weight: 500;
        // .required {
        //     color: #E70A27;
        //     font-size: 16px;
        // }
    }
    .info-value {
        font-size: 14px;
        color: #999999;
    }
    .bind {
        color: #386AEA;
        font-size: 14px;
        text-decoration: underline;
    }
}

.mr-4 {
    margin-right: 4px;
}

.ml-8 {
    margin-left: 8px;
}

.cursor-pointer {
    cursor: pointer;
}

.comfont_style {
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
}

::v-deep .el-tabs__item {
    height: 80px;
    width: 226px;
    font-size: 16px;
    justify-content: center !important;
    color: #333 !important;
    font-weight: bold;
}

::v-deep .el-tabs__content {
    padding: 32px 24px 23px 24px;
}

::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-active):hover {
    background: rgba(56, 106, 234, 0.1);
}

::v-deep .el-tabs--left.el-tabs--border-card .el-tabs__header.is-left {
    border: none;
    height: 100%;
    background-color: #f2f2f2;
    margin-right: 0px;
}

::v-deep .el-tabs--border-card {
    border: none;
}
.user_info_container {
    background-color: #f8f8f8;
    min-height: calc(100vh - 56px);
    .user_info_main {
        padding: 24px 0px 40px;
    }
}

@media (max-width: 1200px) {
    .user_info_content {
        width: calc(100vw - 80px);
        min-height: 953px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 4px;
        overflow: hidden;
    }

}

@media (min-width: 1200px) {
    .user_info_content {
        width: 1105px;
        min-height: 953px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 4px;
        overflow: hidden;
    }
}
</style>
<style lang="scss">
.user_info_content {
    .el-tabs {
        .el-tabs__header {
            .el-tabs__item {
                border: none;
                margin: 0
            }
            .is-active {
                color: #386AEA!important;
                border: none;
            }
        }
        .el-tabs__content {
            padding: 24px 0 32px;
        }
    }
}
.addr_table {
    width: calc(100% + 48px)!important;
    max-width: 120%;
    margin-left: -23px;
    margin-right: -24px;
    // padding-left: 23px;
    .empty-block {
        margin-top: 56px;
    }

    .el-button--text {
        color: #666;
    }

    .el-button--text:focus {
        color: #666;
    }

    .el-button--text:hover {
        color: #666;
    }

    .el-button:not(.el-button--text) {
        width: 64px;
        height: 24px;
        font-size: 12px;
        color: #386AEA;
        border-radius: 2px;
        border: 1px solid #386AEA;
    }

    .el-button:not(.el-button--text):hover {
        background-color: #fff;
    }
}

.addr_table.el-table td.el-table__cell,
.addr_table.el-table th.el-table__cell.is-leaf {
    border-bottom: none;
    height: 56px;
    text-align: center;
}

.addr_table .cell {
    color: #666;
    font-weight: 400;
    font-size: 14px;
}

.addr_table.el-table thead .cell {
    color: #666;
    font-weight: 400;
    font-size: 16px;
}

.addr_table.el-table .cell {
    padding: 0px;
}

.addr_table.el-table .el-table__cell {
    height: 56%;
}

.addr_table .el-table--border .el-table__inner-wrapper::after,
.el-table--border::after,
.el-table--border::before,
.el-table__inner-wrapper::before {
    background-color: #fff;
}

// 英文版样式
.user_info_container_en{
    .com_info_mini1{
        margin-left: 82px!important;

        .info-label{
            width: 143px!important;
        }
    }

    .pass_form{
        width: 581px!important;
        .el-form-item {
            width: 578px!important;
        }

        .el-button{
            margin-left: 187px !important;
        }
    }


    .bot_btn{
        margin: 48px 15px 10px 54px!important;

        .el-button{
            width: 193px!important;
        }
    }

    
}
</style>